import Vue from "vue"

export default Vue.extend({
  template: `
    <div style="display: flex">
      <vs-button
        v-if="$can('update', 'status')"
        radius
        color="primary"
        type="flat"
        icon-pack="feather"
        icon="icon-edit"
        @click="setEditStatus"
      ></vs-button>
      <vs-button
        v-if="$can('delete', 'status')"
        radius
        color="primary"
        type="flat"
        icon-pack="feather"
        icon="icon-trash-2"
        @click="setDeleteStatus"
      ></vs-button>
    </div>
    `,
  data() {
    return {
      value: null
    }
  },
  methods: {
    setEditStatus () {
      if (this.params.data.id == null) {
        this.$vs.notify({
          text: this.$t("status.nonEditableStatus"),
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-circle"
        })
      } else this.$store.dispatch('status/set_status', this.params.data)
    },
    setDeleteStatus () {
      this.$store.dispatch('status/set_delete_status', this.params.data)
    }
  }
})
